import React, { useState, useEffect } from "react";

const QuizzWidgetAnswer = ({ id, answer, imageUrl, checked, onOptionSelect, selectedOptionId, answersCount, hasImage, isBackgroundImage, redirect, redirectionUrl}) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
    }, []);


    return (
        <>
        {hasImage && imageUrl?.length > 0 ?
            <div className={`quizz-widget-answer${answersCount <= 4 ? " quizz-widget-answer--large" : ""}${isBackgroundImage ? " quizz-widget-answer--bg-img" : ""}${checked ? " checked" : ""}${selectedOptionId ? "" : " animated"}${visible ? " visible": ""}`}>
                <div className="quizz-widget-answer__container">
                    <input
                        id={id}
                        type="radio"
                        value={answer}
                        name={id}
                        checked={checked}
                        onChange={() => onOptionSelect(id, redirect, redirectionUrl)}
                    />
                    <label htmlFor={id}>
                        {imageUrl && 
                            <div className="quizz-widget-answer__img-wrapper">
                                <img className="quizz-widget-answer__img" src={imageUrl} />
                            </div>
                        }
                        <div className="quizz-widget-answer__text">{answer}</div>
                    </label>
                </div>
            </div>
        :
            <div className={`quizz-option${answersCount <= 4 ? " quizz-option--large" : ""}${checked ? " checked" : ""}${selectedOptionId ? "" : " animated"}${visible ? " visible": ""}`}>
                <div className="quizz-option__container">
                    <input
                        id={id}
                        type="radio"
                        value={answer}
                        name={id}
                        checked={checked}
                        onChange={() => onOptionSelect(id, redirect, redirectionUrl)} />
                    <label htmlFor={id}>
                        <div className={`quizz-option__text${!imageUrl && answer.length > 25 ? " quizz-option__text--small" : ""}`}>
                            <span>{answer}</span>
                        </div>
                    </label>
                </div>
            </div>
        }
        </>
    );
        
        
};

export default QuizzWidgetAnswer;
